<template lang="pug">
  div
    b-button.mb-2(v-b-toggle.collapse-task-states variant="outline-primary" size="sm")
      | Mostrar / ocultar tarjetas
    b-collapse#collapse-task-states
      #cardResumenTask
        b-card-group.mb-4
          div(v-for="taskSummary in tasksInSummary")
            .card
              .header-card
                font-awesome-icon(:icon="['fas', 'tasks']" size="lg" style="color:  #1C3FAA")
                .title-service {{ taskSummary.name }}
                .percentage(:style="taskSummary.stateColorStyle") {{taskSummary.progressText}}
              h3.progress-service {{ taskSummary.count }}/{{ taskSummary.total }}
              .state-service {{ taskSummary.name }}: Terminado
</template>
<script>
import { mapGetters } from 'vuex'
import stateColors from '../../shared/state_colors'

export default {
  methods: {
    getColor (percent) {
      let colorName = 'Rojo'
      if (percent >= 100) {
        colorName = 'Verde'
      } else if (percent > 0) {
        colorName = 'Amarillo'
      }
      return stateColors.find(color => color.title === colorName).value
    },
    countCompletedTasks (taskId) {
      return this.businessesMonthlyStatesTask.reduce((acum, monthlyStates) => {
        const state = monthlyStates.taskStates.find(state => state.taskId === taskId)
        if (state && state.state === 'Terminado'){
          acum++
        }
        return acum
      }, 0)
    },
    countTasks (taskId) {
      return this.businessesMonthlyStatesTask.reduce((acum, monthlyStates) => {
        const state = monthlyStates.taskStates.find(s => s.taskId === taskId)
        if (state && state.state !== 'N/A'){
          acum++
        }
        return acum
      }, 0)
    }
  },
  computed: {
    ...mapGetters(['tasks']),
    ...mapGetters('BusinessTaskStore',['businessesMonthlyStatesTask']),
    tasksInSummary () {
      return this.tasks.reduce((acum, task) => {
        if (task.showInSummary) {
          const count = this.countCompletedTasks(task.id)
          const total = this.countTasks(task.id)
          let progress = Math.trunc(100 * count / total)
          if (isNaN(progress)) {
            progress = 100
          }
          return acum.concat({
            name: task.name,
            progressText: `${progress}%`,
            stateColorStyle: `background: ${this.getColor(progress)}`,
            count,
            total
          })
        }
        return acum
      }, [])
    }
  }
}
</script>
<style lang="scss" scoped>
#cardResumenTask{
  .card{
    min-width: 16rem; 
    max-width:16rem;
    margin-right: 20px;
    margin-top: 8px;
    border: transparent;
    border-radius: 5px;
    padding: 14px;
    box-shadow: 0px 3px 6px #00000029;
  }
  .header-card{
    display: flex;
    justify-content: space-between;
    align-items:end;
  }
  .title-service{
    font-weight: bold;
    font-size: 17px;
    line-height: 16px;
    width: 150px;
  }
  .percentage{
    border-radius: 6px;
    padding: 4px 11px;
    font-size: 11px;
    color: white;
    width: 50px;
    text-align: center;
  }
  .progress-service{
    margin-top: 7px;
    font-size: 30px;
    margin-bottom: 2px;
  }
  .state-service{
    color: rgb(184, 184, 184);
    font-size: 12px;
    line-height: 10px;
  }
}

</style>